// extracted by mini-css-extract-plugin
export var icon = "_90-3";
export var subtitle = "_90-2";
export var title = "_90-1";
export var value = "_90-0";